import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2 } from "lucide-react";

const B2BLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgotMode, setForgotMode] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const res = await axios.post(`${API}/public/b2b/login`, { email, password: pwd });
      localStorage.setItem("b2b_token", res.data.access_token);
      localStorage.setItem("b2b_ent", JSON.stringify(res.data.entreprise));
      localStorage.setItem("b2b_user", JSON.stringify(res.data.user));
      nav("/b2b-espace");
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Échec de connexion");
    } finally { setLoading(false); }
  };

  const forgotSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await axios.post(`${API}/public/b2b/forgot-password`, { email });
      setForgotSent(true);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Erreur");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-slate-50 p-4">
      <Card className="max-w-md w-full shadow-lg">
        <CardContent className="pt-6 space-y-4">
          <div className="text-center space-y-2">
            <div className="w-14 h-14 mx-auto rounded-2xl bg-indigo-100 flex items-center justify-center">
              <Building2 className="w-7 h-7 text-indigo-600" />
            </div>
            <h1 className="text-2xl font-bold text-slate-800">Portail B2B</h1>
            <p className="text-sm text-slate-500">Espace professionnel TopCocoon</p>
          </div>
          <form onSubmit={forgotMode ? forgotSubmit : submit} className="space-y-3">
            <div>
              <Label>Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="b2b-login-email" />
            </div>
            {!forgotMode && (
              <div>
                <Label>Mot de passe</Label>
                <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} required data-testid="b2b-login-pwd" />
              </div>
            )}
            {err && <p className="text-red-600 text-sm bg-red-50 border border-red-200 rounded px-3 py-2" data-testid="b2b-login-error">{err}</p>}
            {forgotSent ? (
              <p className="text-emerald-700 text-sm bg-emerald-50 border border-emerald-200 rounded px-3 py-2" data-testid="b2b-forgot-sent">
                ✓ Demande envoyée. TopCocoon vous contactera avec un nouveau mot de passe.
              </p>
            ) : (
              <Button type="submit" disabled={loading} className="w-full bg-indigo-600 hover:bg-indigo-700 h-11" data-testid="b2b-login-submit">
                {loading ? "Envoi…" : forgotMode ? "Envoyer la demande" : "Se connecter"}
              </Button>
            )}
            <button
              type="button"
              onClick={() => { setForgotMode(!forgotMode); setForgotSent(false); setErr(""); }}
              className="w-full text-xs text-indigo-600 hover:text-indigo-700 font-medium"
              data-testid="b2b-toggle-forgot"
            >
              {forgotMode ? "← Retour à la connexion" : "Mot de passe oublié ?"}
            </button>
          </form>
          <p className="text-xs text-center text-slate-400">Pas de compte ? <a href="/b2b-register" className="text-indigo-600 hover:text-indigo-700 font-medium" data-testid="b2b-goto-register">Créer un compte pro →</a></p>
        </CardContent>
      </Card>
    </div>
  );
};

export default B2BLogin;
